// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aadd3b2e","732":"310b3a79","977":"1b452be2"}[chunkId] + ".chunk.js";
};